import * as yup from "yup";

const startOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};
export const CreateStudentDebtFormValidation = yup.object().shape({
  idStudent: yup.string().required("Estudante é obrigatório"),
  idPaymentType: yup.string().required("Tipo de emolumento é obrigatório"),
  originalAmount: yup
    .number()
    .typeError("deve ser valor")
    .required("Valor é obrigatória"),
  currentAmount: yup
    .number()
    .typeError("deve ser valor")
    .required("Valor é obrigatória"),
  dueDate: yup.string().required(),
  bankEntity: yup.string().when("generateRef", {
    is: "true",
    then: (schema) => schema.required("Campo obrigatório"),
    otherwise: (schema) => schema.optional(),
  }),
});
